import React from 'react';
import propTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert
} from 'reactstrap';
import classNames from 'classnames';
import { hasError, errorMessage, textChange, textValue } from '../../../utils/form';
import { ButtonLoading } from '../../../components/Button';
import { returnResolutionOptions } from '../../../constants/kickavenue';

class ModalReturnResolution extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      id: null,
      return_resolution: '',
      error: null
    }
    this._handleChange = this._handleChange.bind(this);
    this._onFormSubmit = this._onFormSubmit.bind(this);
  }

  _handleChange(e){
    this.setState(textChange(e, {...this.state}));
  }

  componentDidUpdate(prevProps) {
    if(!prevProps.isOpen && prevProps.isOpen !== this.props.isOpen){
      this.setState({
        id: this.props.id,
        return_resolution: '',
        error: null
      })
    }
    if(prevProps.isSubmit && prevProps.isSubmit !== this.props.isSubmit){
      const { errorData } = this.props;
      if(errorData){
        this.setState({
          error: { ...errorData }
        })
      }
    }
  }

  _onFormSubmit(e){
    e.preventDefault();
    const { id, return_resolution } = this.state;
    const payload = { return_resolution };
    this.props.onSubmit(id, payload);
  }

  render(){
    return(
      <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel}>
        <ModalHeader toggle={this.props.onCancel}>
          Set Return Resolution
        </ModalHeader>
        <ModalBody>
          {this.state.error && this.state.error.message && (
            <Alert color="danger">
              <strong>Error!</strong> {this.state.error.message}
            </Alert>
          )}
          <p>
            Select the return resolution for this sale. This action will update the sale record with the selected resolution.
          </p>
          <Form onSubmit={this._onFormSubmit}>
            <FormGroup className={classNames({'has-danger has-feedback': hasError('return_resolution', this.state.error)})}>
              <Label for="formReturnResolution">Return Resolution*</Label>
              <Input
                type="select"
                id="formReturnResolution"
                name="return_resolution"
                value={textValue('return_resolution', this.state)}
                onChange={this._handleChange}
              >
                <option value="">Select return resolution...</option>
                {
                  returnResolutionOptions.map(({ value, label }) => (
                    <option key={value} value={value}>{label}</option>
                  ))
                }
              </Input>
              {errorMessage('return_resolution', this.state.error)}
            </FormGroup>
          </Form>
          <span className="text-sm">Fields marked with * are required</span>
        </ModalBody>
        <ModalFooter>
          <ButtonLoading
            color="primary"
            isLoading={this.props.isSubmit}
            onClick={this._onFormSubmit}
          >
            Confirm
          </ButtonLoading>
          <Button color="secondary" onClick={this.props.onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ModalReturnResolution;

ModalReturnResolution.defaultProps = {
  isOpen: false,
  isSubmit: false,
  errorData: null
}

ModalReturnResolution.propTypes = {
  isOpen: propTypes.bool,
  isSubmit: propTypes.bool,
  id: propTypes.oneOfType([propTypes.number, propTypes.string]),
  errorData: propTypes.object,
  onCancel: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired
}
